import { useEffect, useMemo } from 'react';
import { t, tHTML } from '@ankr.com/common';
import { i18n } from '@ankr.com/common';

import { Locale } from '../types/locale';

const DEFAULT_LOCALE = Locale.en;

type TFunction = (
  key: string,
  variables?: object,
  withHTML?: boolean,
) => string;

type PartialLocale = Locale | string;

type Translation<T extends Record<string, string | Record<string, string>>> =
  Record<PartialLocale, T>;

type UseTranslationResult<
  T extends Record<string, string | Record<string, string>>,
> = {
  t: TFunction;
  tHTML: TFunction;
  keys: T;
  locale: Locale;
};

export function useTranslation<
  T extends Record<string, string | Record<string, string>>,
>(data: Translation<T>): UseTranslationResult<T> {
  const locale = DEFAULT_LOCALE;

  useEffect(() => {
    if (!i18n.hasResourceBundle(locale, 'translation')) {
      i18n.addResourceBundle(locale, 'translation', data[locale], true, true);
    }
  }, [data, locale]);

  const keys = useMemo(() => data[DEFAULT_LOCALE], [data]);

  return {
    t,
    tHTML,
    keys,
    locale,
  };
}
